import { getDateUtilsConfig } from '@ninja/utilities';

const hourItems = () => {
    const { timeFormat } = getDateUtilsConfig();
    if (timeFormat === '12hr') {
        return Array.from({ length: 12 }, (_, index) => ({
            value: index,
            label: `${index === 0 ? 12 : index < 10 ? `0${index}` : index}`,
        }));
    }
    return Array.from({ length: 24 }, (_, index) => ({
        value: index,
        label: `${index < 10 ? `0${index}` : index}`,
    }));
};
const minuteItems = Array.from({ length: 60 }, (_, index) => ({
    value: index,
    label: `${index < 10 ? `0${index}` : index}	`,
}));
const ampmItems = [
    { value: 'AM', label: 'AM' },
    { value: 'PM', label: 'PM' },
];

export { ampmItems, hourItems, minuteItems };
